import {
    ECurrencyType,
    getPairCoinTypes,
    ICurrencyDto,
    TPriceRespApiDto,
} from 'nexchange-service/module/coins'

import { TCoinInputDto } from './selectedCoins'

const mapApiPairDtoToCoinDtos = ({
    apiPairDto,
    availableCurrencies = [],
}: {
    apiPairDto: TPriceRespApiDto
    availableCurrencies: ICurrencyDto[]
}): { fromCoinInputDto: TCoinInputDto; toCoinInputDto: TCoinInputDto } => {
    const {
        pair: { base, quote },
        price, // price in BTC
        amount_base,
        amount_quote,
        max_amount_base,
        max_amount_quote,
        min_amount_base,
        min_amount_quote,
    } = apiPairDto

    const { fromCurrencyType, toCurrencyType } = getPairCoinTypes({
        availableCurrencies,
        fromCode: quote,
        toCode: base,
    })

    return {
        fromCoinInputDto: {
            code: quote,
            isCrypto: fromCurrencyType === ECurrencyType.CRYPTO,
            amount: amount_quote,
            minAmount: min_amount_quote,
            maxAmount: max_amount_quote,
        },
        toCoinInputDto: {
            code: base,
            isCrypto: toCurrencyType === ECurrencyType.CRYPTO,
            amount: amount_base,
            minAmount: min_amount_base,
            maxAmount: max_amount_base,
        },
    }
}

export { mapApiPairDtoToCoinDtos }
